import { doPost } from "../api/OMSAPI"
import { store } from "../../../store/store"

import { loaderModal } from "../AlertLoaderService"
import { isObjectEmpty, isObjectNotEmpty } from "../CommonUtils"
import { updateUserSelectedLocationToRedux } from "../redux/commonRedux"
import { extendAddressDataList, extendLocationData } from "../ExtendedDataUtils"
import { selectedLocationForDashboard, UserSavedAddressSubscription } from "../subject-behaviour/CommonRxjsService"

export const getUserSavedAddress = () => {
    doPost('user/address/list', {}).then(
        (response: any) => {
            let addressList = extendAddressDataList(response['addressList'])
            UserSavedAddressSubscription.setSavedAddress({
                hasFetched: true, addressList: addressList
            })
        }, (err: any) => { console.log("API is failed with error " + err) }
    )
}

export const DeleteUserAddress = (addressData, updateSavedLocation) => {
    loaderModal.setLoader(true);
    doPost('user/address/delete', { 'aid': addressData['aid'] }).then(
        (response: any) => {
            updateSavedLocation(response['addressList'])
            UserSavedAddressSubscription.setSavedAddress({
                hasFetched: true, addressList: response['addressList']
            })
            const reduxState: any = store.getState();
            if (isObjectNotEmpty(reduxState.selectedLocation)) {
                let userSelectedLocation = reduxState.selectedLocation
                if (userSelectedLocation['aid'] == addressData['aid']) {
                    // IN case of reorder, don't knwo what to do.
                    // Drop reorder, or keep selected location data.
                    // Dashboard Screen subscriber.
                    updateUserSelectedLocationToRedux({})
                    selectedLocationForDashboard.setSelectedLocation({})
                }
            }
            loaderModal.setLoader(false);
        }, (err: any) => loaderModal.setLoader(false)
    )
}

export const checkIsAddressCompleted = (address) => {
    let isAddressCompleted = false
    if (isObjectEmpty(address)) return isAddressCompleted
    if (address?.aid && address?.isAddressCompleted)
        isAddressCompleted = true
    return isAddressCompleted
}